import { jsx as _jsx } from "react/jsx-runtime";
import { useStylesV2 } from '@kubit/web-ui-product-components';
// Components
import { DetailOrchestratorComponent } from './components/orchestrator/detail-orchestrator.component';
// Constants
import { STYLES_NAME } from '../../constants/stylesName';
// Enumerations
import { DetailAlignmentVariantEnum, DetailVariantEnum, } from '../../designSystem/reloaded/commons/components/detail';
// Styles
import { DetailComponentStyled } from './detail.component.styled';
export const DetailComponent = ({ alignment = DetailAlignmentVariantEnum.VERTICAL, variant = DetailVariantEnum.PARAGRAPH, ...props }) => {
    const variantStyles = useStylesV2({
        styleName: STYLES_NAME.DETAIL,
        variantName: variant,
    });
    const styles = variantStyles?.[alignment];
    return (_jsx(DetailComponentStyled, { styles: styles, children: _jsx(DetailOrchestratorComponent, { ...props, variant, styles }) }));
};
//# sourceMappingURL=detail.component.js.map